<template>
  <div data-v-3df10ef6="" data-v-e5781868="" class="chess AS mainContent top50" style="background: #fafafa;">
    <div data-v-3df10ef6="" class="content">
      <div data-v-3df10ef6="" class="banner">
        <div data-v-3df10ef6="" class="swiper-container swiper-container-initialized swiper-container-horizontal">
          <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px)">
            <div data-v-3df10ef6="" class="swiper-slide swiper-slide-active" style="width: 1330px">
              <img data-v-3df10ef6="" src="/static/image/banner-chess-048e61b25567cb51307fbafc7567f7fcd.png_.webp" />
              <div data-v-3df10ef6="" class="info">
                <div data-v-3df10ef6="" class="title"></div>
        
              </div>
            </div>
          </div>
          <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span><span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
        </div>
      </div>
   <div data-v-3df10ef6="" class="list" >
        <div data-v-3df10ef6="" class="t">
          <svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon iconThumb">
            <use data-v-338e1447="" xlink:href="#icon-iconThumb"></use>
          </svg>
          热门游戏
          <div data-v-3df10ef6="" class="tools">
            <span data-v-3df10ef6="" slot="button-prev" class="item swiper-button-prev" tabindex="0" role="button" aria-label="Previous slide" aria-disabled="false"
              ><svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon icon iconArrowLeft">
                <use data-v-338e1447="" xlink:href="#icon-iconArrowLeft"></use></svg></span
            ><span data-v-3df10ef6="" slot="button-next" class="item swiper-button-next" tabindex="0" role="button" aria-label="Next slide" aria-disabled="false"
              ><svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon icon iconArrowRight">
                <use data-v-338e1447="" xlink:href="#icon-iconArrowRight"></use></svg
            ></span>
          </div>
        </div>
        <div data-v-3df10ef6="" class="c">
          <div data-v-3df10ef6="" class="swiper-container swiper swiper-container-horizontal">
            <div class="swiper-wrapper" style="transition-duration: 0ms; transform: translate3d(-337.5px, 0px, 0px)">
              <div data-v-3df10ef6="" class="swiper-slide swiper-slide-prev" style="width: 317.5px; margin-right: 20px" v-for="(item, index) in gameList" :key="index"  v-if="item.app_state == 1" >
                <div data-v-3df10ef6="" class="item">
                  <div data-v-3df10ef6="" class="img">
                    <img data-v-3df10ef6="" :src="`/static/image/joker/${item.platform_name}qp.png`" />
                    <div data-v-3df10ef6="" class="mask" style="display: none"><img data-v-3df10ef6="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-3df10ef6="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-3df10ef6="" class="info" v-if="item.app_state == 1 ">
                    <h3 data-v-3df10ef6="">{{item.name}}</h3>
                    <a data-v-3df10ef6="" class="button buttonBordered"  @click="$parent.openGamePage(item.platform_name, item.game_code, '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                      <div data-v-3df10ef6="" class="info" v-else >
                    <h3 data-v-3df10ef6="">{{item.name}}</h3>
                    <a data-v-3df10ef6="" class="button buttonBordered"  
                      >维护中
                      <svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
          
      
            </div>
            <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span><span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
          </div>
        </div>
      </div>
      <div data-v-3df10ef6="" class="list" v-if="false">
        <div data-v-3df10ef6="" class="t">
          <svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon iconThumb">
            <use data-v-338e1447="" xlink:href="#icon-iconThumb"></use>
          </svg>
          热门游戏
          <div data-v-3df10ef6="" class="tools">
            <span data-v-3df10ef6="" slot="button-prev" class="item swiper-button-prev" tabindex="0" role="button" aria-label="Previous slide" aria-disabled="false"
              ><svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon icon iconArrowLeft">
                <use data-v-338e1447="" xlink:href="#icon-iconArrowLeft"></use></svg></span
            ><span data-v-3df10ef6="" slot="button-next" class="item swiper-button-next" tabindex="0" role="button" aria-label="Next slide" aria-disabled="false"
              ><svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon icon iconArrowRight">
                <use data-v-338e1447="" xlink:href="#icon-iconArrowRight"></use></svg
            ></span>
          </div>
        </div>
        <div data-v-3df10ef6="" class="c">
          <div data-v-3df10ef6="" class="swiper-container swiper swiper-container-horizontal">
            <div class="swiper-wrapper" style="transition-duration: 0ms; transform: translate3d(-337.5px, 0px, 0px)">
              <div data-v-3df10ef6="" class="swiper-slide swiper-slide-prev" style="width: 317.5px; margin-right: 20px">
                <div data-v-3df10ef6="" class="item">
                  <div data-v-3df10ef6="" class="img">
                    <img data-v-3df10ef6="" src="/static/image/form-2410-0-de684a7fc5641fae5f2432f70cbfb572.png" />
                    <div data-v-3df10ef6="" class="mask" style="display: none"><img data-v-3df10ef6="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-3df10ef6="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-3df10ef6="" class="info">
                    <h3 data-v-3df10ef6="">BBIN棋牌</h3>
                    <a data-v-3df10ef6="" class="button buttonBordered"  @click="$parent.openGamePage('bbin', 'bbinqp', '')" 
                      >快速游戏
                      <svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <div data-v-3df10ef6="" class="swiper-slide swiper-slide-active" style="width: 317.5px; margin-right: 20px">
                <div data-v-3df10ef6="" class="item">
                  <div data-v-3df10ef6="" class="img">
                    <img data-v-3df10ef6="" src="/static/image/form-2410-0-679bef303ff25670994028604578971f.png" />
                    <div data-v-3df10ef6="" class="mask" style="display: none"><img data-v-3df10ef6="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-3df10ef6="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-3df10ef6="" class="info">
                    <h3 data-v-3df10ef6="">BG棋牌</h3>
                    <a data-v-3df10ef6="" class="button buttonBordered"  @click="$parent.openGamePage('bg', 'qpgame', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <div data-v-3df10ef6="" class="swiper-slide swiper-slide-next" style="width: 317.5px; margin-right: 20px">
                <div data-v-3df10ef6="" class="item">
                  <div data-v-3df10ef6="" class="img">
                    <img data-v-3df10ef6="" src="/static/image/form-2410-0-040765e6087c9088e1ed84e284cad516.png" />
                    <div data-v-3df10ef6="" class="mask" style="display: none"><img data-v-3df10ef6="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-3df10ef6="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-3df10ef6="" class="info">
                    <h3 data-v-3df10ef6="">大唐棋牌</h3>
                    <a data-v-3df10ef6="" class="button buttonBordered"  @click="$parent.openGamePage('datqp', '2', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <div data-v-3df10ef6="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-3df10ef6="" class="item">
                  <div data-v-3df10ef6="" class="img">
                    <img data-v-3df10ef6="" src="/static/image/form-2410-0-2e38923fb91a6374b5048eb48d4ebf22.png" />
                    <div data-v-3df10ef6="" class="mask" style="display: none"><img data-v-3df10ef6="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-3df10ef6="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-3df10ef6="" class="info">
                    <h3 data-v-3df10ef6="">FG棋牌</h3>
                    <a data-v-3df10ef6="" class="button buttonBordered"  @click="$parent.openGamePage('fg', '2', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <div data-v-3df10ef6="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-3df10ef6="" class="item">
                  <div data-v-3df10ef6="" class="img">
                    <img data-v-3df10ef6="" src="/static/image/form-2410-0-93dc27ec7a2607d65af6e11040bc9468.png" />
                    <div data-v-3df10ef6="" class="mask" style="display: none"><img data-v-3df10ef6="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-3df10ef6="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-3df10ef6="" class="info">
                    <h3 data-v-3df10ef6="">欢乐棋牌</h3>
                    <a data-v-3df10ef6="" class="button buttonBordered"  @click="$parent.openGamePage('hlgame', '1', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <div data-v-3df10ef6="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-3df10ef6="" class="item">
                  <div data-v-3df10ef6="" class="img">
                    <img data-v-3df10ef6="" src="/static/image/form-2410-0-2c27d6ab0b35f47316bd21d4b3c347f5.png" />
                    <div data-v-3df10ef6="" class="mask" style="display: none"><img data-v-3df10ef6="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-3df10ef6="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-3df10ef6="" class="info">
                    <h3 data-v-3df10ef6="">凯旋棋牌</h3>
                    <a data-v-3df10ef6="" class="button buttonBordered"  @click="$parent.openGamePage('kx', '1', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <div data-v-3df10ef6="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-3df10ef6="" class="item">
                  <div data-v-3df10ef6="" class="img">
                    <img data-v-3df10ef6="" src="/static/image/form-2410-0-59e2bb7abadbb594ee3d9e7bf7e8bf5f.png" />
                    <div data-v-3df10ef6="" class="mask" style="display: none"><img data-v-3df10ef6="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-3df10ef6="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-3df10ef6="" class="info">
                    <h3 data-v-3df10ef6="">凯旋2棋牌</h3>
                    <a data-v-3df10ef6="" class="button buttonBordered"  @click="$parent.openGamePage('kx2', '2', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <div data-v-3df10ef6="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-3df10ef6="" class="item">
                  <div data-v-3df10ef6="" class="img">
                    <img data-v-3df10ef6="" src="/static/image/form-2410-0-69ff5f10bfaa4266769d8ed382922e84.png" />
                    <div data-v-3df10ef6="" class="mask" style="display: none"><img data-v-3df10ef6="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-3df10ef6="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-3df10ef6="" class="info">
                    <h3 data-v-3df10ef6="">开元棋牌</h3>
                    <a data-v-3df10ef6="" class="button buttonBordered"  @click="$parent.openGamePage('leg', '7', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <div data-v-3df10ef6="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-3df10ef6="" class="item">
                  <div data-v-3df10ef6="" class="img">
                    <img data-v-3df10ef6="" src="/static/image/form-2410-0-69ff5f10bfaa4266769d8ed382922e84.png" />
                    <div data-v-3df10ef6="" class="mask" style="display: none"><img data-v-3df10ef6="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-3df10ef6="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-3df10ef6="" class="info">
                    <h3 data-v-3df10ef6="">OB棋牌</h3>
                    <a data-v-3df10ef6="" class="button buttonBordered"  @click="$parent.openGamePage('obgqp', '2', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <div data-v-3df10ef6="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-3df10ef6="" class="item">
                  <div data-v-3df10ef6="" class="img">
                    <img data-v-3df10ef6="" src="/static/image/form-2410-0-69ff5f10bfaa4266769d8ed382922e84.png" />
                    <div data-v-3df10ef6="" class="mask" style="display: none"><img data-v-3df10ef6="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-3df10ef6="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-3df10ef6="" class="info">
                    <h3 data-v-3df10ef6="">双赢棋牌</h3>
                    <a data-v-3df10ef6="" class="button buttonBordered"  @click="$parent.openGamePage('sy', '2', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <div data-v-3df10ef6="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-3df10ef6="" class="item">
                  <div data-v-3df10ef6="" class="img">
                    <img data-v-3df10ef6="" src="/static/image/form-2410-0-69ff5f10bfaa4266769d8ed382922e84.png" />
                    <div data-v-3df10ef6="" class="mask" style="display: none"><img data-v-3df10ef6="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-3df10ef6="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-3df10ef6="" class="info">
                    <h3 data-v-3df10ef6="">VG棋牌</h3>
                    <a data-v-3df10ef6="" class="button buttonBordered"  @click="$parent.openGamePage('vg', '2', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <div data-v-3df10ef6="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-3df10ef6="" class="item">
                  <div data-v-3df10ef6="" class="img">
                    <img data-v-3df10ef6="" src="/static/image/form-2410-0-69ff5f10bfaa4266769d8ed382922e84.png" />
                    <div data-v-3df10ef6="" class="mask" style="display: none"><img data-v-3df10ef6="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-3df10ef6="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-3df10ef6="" class="info">
                    <h3 data-v-3df10ef6="">新世界棋牌</h3>
                    <a data-v-3df10ef6="" class="button buttonBordered"  @click="$parent.openGamePage('xsj', '1', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <div data-v-3df10ef6="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-3df10ef6="" class="item">
                  <div data-v-3df10ef6="" class="img">
                    <img data-v-3df10ef6="" src="/static/image/form-2410-0-69ff5f10bfaa4266769d8ed382922e84.png" />
                    <div data-v-3df10ef6="" class="mask" style="display: none"><img data-v-3df10ef6="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-3df10ef6="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-3df10ef6="" class="info">
                    <h3 data-v-3df10ef6="">乐游棋牌</h3>
                    <a data-v-3df10ef6="" class="button buttonBordered"  @click="$parent.openGamePage('ly', '1', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-3df10ef6="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
            </div>
            <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span><span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'cards',
  data() {
    return {
         gameList: [],

    };
  },
  created() {
    let that = this;
    that.getGameList();

  },
  methods: {
                getGameList() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun.get('/api/game/list', { category: 'joker' }).then(res => {
        if (res.code == 200) {
          that.gameList = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
  },
  mounted() {
    let that = this;
  
  },
  updated() {
    let that = this;
    var mySwiper = new Swiper('.bannerSwiper .swiper', {
      slidesPerView: 'auto',
      pagination: {
        el: '.bannerSwiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.bannerSwiper .swiper-button-next',
        prevEl: '.bannerSwiper .swiper-button-prev',
      },
    });
    var swiperList = new Swiper('.box .swiper-img', {
      navigation: {
        nextEl: '.swiper-img .swiper-button-next',
        prevEl: '.swiper-img .swiper-button-prev',
      },
    });
    var swiper = new Swiper('.k8BrandWay .c .timeline .swiper', {
      navigation: {
        nextEl: '.k8BrandWay .c .timeline .tool.next',
        prevEl: '.k8BrandWay .c .timeline .tool.prev',
      },
    });
    $('.k8BrandWay .c .timeline .swiper .swiper-slide .swiper-content .items .item').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      var u = $(this).index();
      var b = ((u + 1) / 7) * 100;
      console.log(b);
      $(this)
        .parents('.swiper-slide')
        .find('.swiper-content .line .activeState')
        .css('width', b + '%');
      var i = $(this).parents('.swiper-slide').index();
      if (i > 1) {
        for (var t = 0; t < i; t++) {
          if (t > 1) {
            $('.k8BrandWay .c .timeline .swiper .swiper-slide').eq(t).find('.swiper-content .line .activeState').css('width', '100%');
          }
        }
      }
      var m = i * 7;
      var o = m + u;
      swiperList.slideTo(o, 1000, false);
    });
    $('.table table tr').click(function () {
      $('.table table tr').removeClass('active');
      $(this).addClass('active');
      var username = $(this).find('td').eq(1).text();
      var amount = $(this).find('td').eq(2).text();
      $('.profit .user-name').text('会员' + username);
      $('.profit .amount h1').text(amount.replace('元', ''));
    });
    var gameSwipper = new Swiper('.banner .swiper-container', {});

    var listSwipper = new Swiper('.swiper', {
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
      slidesPerView: 4,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/chunk-6cc178e1.70a3ba40.css';
</style>



// WEBPACK FOOTER //
// src/components/mode/cards.vue